module.exports = __webpack_public_path__ + "img/img-6.4052130f.webp";